import React from 'react'
import usePointrThemedFormItem from './Styles'
import { FormControl, InputLabel, FormHelperText, FormLabel } from '@material-ui/core'
import { PointrThemedInput } from 'components'
import { uniqueId } from 'lodash'
import { IPointrThemedFormItem } from './Interfaces'

const PointrThemedFormItem: React.FC<IPointrThemedFormItem> = ({
  label,
  value,
  type,
  error,
  disabled,
  onChange,
  onFocus,
  onBlur,
  helperText,
  InputProps,
  maxLength,
  rows,
  multiline,
  placeholder,
  classes: stylesOverrides
}) => {
  const inputId = `pointr-themed-form-item-${uniqueId()}`
  const classes = usePointrThemedFormItem({})

  return (
    <div className={classes.formRow}>
      <FormControl className={classes.formControl} error={error}>
        {!!label && (
          <InputLabel id={`${inputId}-label`} className={stylesOverrides?.label} shrink htmlFor={inputId}>
            {label}
          </InputLabel>
        )}
        <PointrThemedInput
          {...(InputProps || {})}
          id={inputId}
          value={value}
          type={type}
          onFocus={onFocus}
          onChange={onChange}
          rows={rows}
          inputProps={{
            maxLength,
            onFocus,
            onBlur
          }}
          placeholder={placeholder}
          disabled={disabled}
          multiline={multiline}
          endAdornment={
            maxLength ? (
              <FormLabel className={classes.characterCounter}>{`${(value || '').length}/${maxLength}`}</FormLabel>
            ) : null
          }
        />
        {helperText && <FormHelperText id={`${inputId}-helper-label`}>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  )
}

PointrThemedFormItem.defaultProps = {
  type: 'text',
  error: false,
  helperText: null,
  value: ''
}

export default PointrThemedFormItem
